<template>
  <!-- REGISTER/DEREGISTER SUCCESS -->
  <v-snackbar
      v-model="showSnack"
      max-width="600"
      light
      timeout="5000"
      bottom
      right
      class="rounded-lg"
  >
    <div class="d-flex flex-column justify-center align-center" style="width: 100%; height: 100%;">
      <template v-if="mode === 'registered'">
        <div>
          <v-icon size="100" color="success" class="ma-6 fa-beat" style="--fa-animation-iteration-count: 1; --fa-animation-duration: 1.5s; --fa-animation-timing: ease-in-out;">fal fa-circle-check</v-icon>
        </div>
        <div v-html="$t('cards.texts.registerSuccess', { challenge: title })"></div>
      </template>
      <template v-if="mode === 'deregistered'">
        <div>
          <v-icon size="100" color="success" class="ma-6 fa-beat" style="--fa-animation-iteration-count: 1; --fa-animation-duration: 1.5s; --fa-animation-timing: ease-in-out;">fal fa-circle-check</v-icon>
        </div>
        <div v-html="$t('cards.texts.deregisterSuccess', { challenge: title })"></div>
      </template>
      <v-btn
          class="mt-3"
          color="primary"
          text
          small
          depressed
          @click="showSnack = false"
      >
        {{ $t('buttons.close') }}
      </v-btn>
    </div>
  </v-snackbar>
</template>

<script>

export default {
  name: "m2h-snackbar",
  data() {
    return {
      isLoading: false,
      showSnack: false,
      mode: '',
      title: ''
    }
  },

  mounted(){
    this.$root.$on('open-snackbar', (data) => {
      this.mode = data.mode
      this.title = data.title
      this.showSnack = true
    })
  },

  methods: {
  }
}
</script>

<style scoped>

</style>
